// Zod DTOs for the `/v1/subjects` authoring surface (spec §3.3 `Subject`
// model, §6.2; ADR-001 "Subject layer is MANDATORY"). `levelId` is a path
// param (`POST /v1/levels/:id/subjects`), never part of the body.
import { z } from 'zod';
import { reorderRequestSchema, slugSchema, titleSchema } from './primitives';

// ─── POST /v1/levels/:id/subjects ───────────────────────────────────────────

export const subjectCreateRequestSchema = z.object({
  name: titleSchema,
  slug: slugSchema.optional(),
});
export type SubjectCreateRequest = z.infer<typeof subjectCreateRequestSchema>;

// ─── PATCH /v1/subjects/:id ──────────────────────────────────────────────────

export const subjectUpdateRequestSchema = subjectCreateRequestSchema.partial();
export type SubjectUpdateRequest = z.infer<typeof subjectUpdateRequestSchema>;

// ─── POST /v1/subjects/reorder ───────────────────────────────────────────────

export const subjectReorderRequestSchema = reorderRequestSchema;
export type SubjectReorderRequest = z.infer<typeof subjectReorderRequestSchema>;
